import { AppBar, FormControl, Grid, InputLabel, Select, Tooltip, Typography } from '@material-ui/core';
import { useCallback, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { AssociatedPerson, DealDetail } from '@lib/deals';
import * as adapter from './form-adapter';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { thumbStack } from '@lib/common/css';
import { vestResolver } from '@hookform/resolvers/vest';
import { P2CValidationSuite } from './validators';
import { useFormSnackbarError, useRecentCallback } from '@lib/common';
import { PersonEntity, ContentEntity, P2CAddFormEntity } from '../types';
import { P2CContentSelector, P2CPersonSelector } from '../p2c-features/p2c-add-entities';
import { FormActions } from './form-actions';
import { blue } from '@material-ui/core/colors';
import { ControlledTextField } from 'pages/person-management/person-management-form/person-master-relation-form';

type P2CFormProps = {
  onSubmit: (formData: P2CAddFormEntity) => any;
  onDelete?: (formData: P2CAddFormEntity) => any;
  deal: DealDetail;
  createDeal?: boolean;
};

export function P2CAddForm({ deal, onSubmit, onDelete = null, createDeal = false }: P2CFormProps) {
  const formDeal = useMemo(() => adapter.toForm(deal as any), [deal]);
  const form = useForm({
    defaultValues: formDeal,
    resolver: vestResolver(P2CValidationSuite),
    reValidateMode: 'onSubmit',
  });

  const [onFinish] = useRecentCallback(deal => onSubmit(deal));
  const [showComments, setShowComments] = useState(false);

  const formError = useFormSnackbarError();

  const submitForm = form.handleSubmit(onFinish, formError);
  const formGrid = (
    <Grid container spacing={1}>
      <Grid item xs={12} style={{ marginBottom: "50px" }}>
        <P2CPersonSelector deal={formDeal} />
      </Grid>
      <br />
      <br />
      <Grid item xs={12}>
        <P2CContentSelector deal={formDeal} />
      </Grid>
      <br />
      <br />
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Sources
        </Typography>
        <ControlledTextField
          fullWidth
          variant="outlined"
          name={'sources'}
          label={'Sources Link'}
          control={form.control}
          defaultValue={''}
          multiline
          rows={3}
        />
      </Grid>
    </Grid>
  );

  const PersonContentMappingAppBar = () => {
    return (
      <AppBar color="secondary" style={{ position: 'sticky', marginBottom: "40px", background: blue[800] }}>
        <Grid
          container
          justify="flex-end"
          alignItems="flex-end"
          spacing={2}
          style={{ margin: 0, width: '100%' }}>
          <Grid item>
            <FormActions
              submitForm={submitForm}
            />
          </Grid>
        </Grid>
      </AppBar>
    );
  };

  return (
    <FormProvider {...form}>
      <PersonContentMappingAppBar />
      <form onSubmit={submitForm}>
        <input hidden name="id" ref={form.register} />
        <Grid style={{ position: 'relative' }} container spacing={3}>
          <Grid item xs={showComments ? 9 : 12}>
            {formGrid}
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
} 